// src/About.jsx
import React from "react";

export default function About() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>About Synkro</h1>
      <p>This is the about page for Synkro.in</p>
    </div>
  );
}
